import { Component} from '@angular/core';
import { UrlDecider } from '../shared/lib/url-decider';

@Component({
  selector: 'app-locations',
  templateUrl: './locations.component.html',
  styleUrls: ['./locations.component.css']
})
export class LocationsComponent {

  langSelector = 'eng';

  bannerImage = '/images/header-footer-strip/02.jpg';

  constructor() {
    this.langSelector = UrlDecider.getLangFromUrl();
  }

}
